import {memo, ReactNode} from "react";
import {css} from "@panda/css";

import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FormFieldType, toQueryValues} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {IPropertyListProperty} from "../../../../property/types/PropertyListProperty";
import {IPropertyListObj} from "../../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../../property_list/PropertyListFilters";
import {PropertyListTileList} from "../../../../property_list/PropertyListTileList";
import {IOfferDetail} from "../../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
    propertyListObj: IPropertyListObj;
    filterValues: ISearchFiltersFormValues;
    renderPropertyTile?: (property: IPropertyListProperty) => ReactNode;
    gtmMeta: {
        listName: string;
        listId: string;
    };
}

export const propertyListTilesFilterFields = {
    area: FormFieldType.InputRange,
    rooms: FormFieldType.SelectRangeNumber,
    price: FormFieldType.InputRange,
    floor_choices: FormFieldType.MultiCheckbox,
    house_storeys: FormFieldType.MultiCheckbox,
    construction_end_date: FormFieldType.Checkbox
};

export const OfferDetailPropertyListTiles = memo((props: IProps) => {
    const {offer, propertyListObj, filterValues, renderPropertyTile, gtmMeta} = props;

    const {pageCount, onPageChange, page, filterRequestState, properties} = propertyListObj;

    const {isMobile} = useUserDevice();

    const handlePageChange = (value: number) => {
        const filterQueryValues = toQueryValues(propertyListTilesFilterFields, filterValues);

        onPageChange(value, filterQueryValues, true);
    };

    return (
        <>
            <PropertyListTileList
                requestState={filterRequestState}
                properties={properties}
                offer={offer}
                className={propertyListWrapperStyle}
                renderPropertyTile={renderPropertyTile}
                gtmMeta={gtmMeta}
            />

            {pageCount > 0 && (
                <Pagination
                    currentPage={page.currentPage}
                    pageCount={pageCount}
                    onPageChange={handlePageChange}
                    size={isMobile ? PaginationSize.SM : PaginationSize.MD}
                    siblingsCount={isMobile ? 0 : 1}
                />
            )}
        </>
    );
});

const propertyListWrapperStyle = css({
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
    "& > ul": {
        px: 0,
        width: "100%"
    }
});
import {memo, ReactNode} from "react";
import {css} from "@panda/css";

import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FormFieldType, toQueryValues} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {IPropertyListProperty} from "../../../../property/types/PropertyListProperty";
import {IPropertyListObj} from "../../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../../property_list/PropertyListFilters";
import {PropertyListTileList} from "../../../../property_list/PropertyListTileList";
import {IOfferDetail} from "../../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
    propertyListObj: IPropertyListObj;
    filterValues: ISearchFiltersFormValues;
    renderPropertyTile?: (property: IPropertyListProperty) => ReactNode;
    gtmMeta: {
        listName: string;
        listId: string;
    };
}

export const propertyListTilesFilterFields = {
    area: FormFieldType.InputRange,
    rooms: FormFieldType.SelectRangeNumber,
    price: FormFieldType.InputRange,
    floor_choices: FormFieldType.MultiCheckbox,
    house_storeys: FormFieldType.MultiCheckbox,
    construction_end_date: FormFieldType.Checkbox
};

export const OfferDetailPropertyListTiles = memo((props: IProps) => {
    const {offer, propertyListObj, filterValues, renderPropertyTile, gtmMeta} = props;

    const {pageCount, onPageChange, page, filterRequestState, properties} = propertyListObj;

    const {isMobile} = useUserDevice();

    const handlePageChange = (value: number) => {
        const filterQueryValues = toQueryValues(propertyListTilesFilterFields, filterValues);

        onPageChange(value, filterQueryValues, true);
    };

    return (
        <>
            <PropertyListTileList
                requestState={filterRequestState}
                properties={properties}
                offer={offer}
                className={propertyListWrapperStyle}
                renderPropertyTile={renderPropertyTile}
                gtmMeta={gtmMeta}
            />

            {pageCount > 0 && (
                <Pagination
                    currentPage={page.currentPage}
                    pageCount={pageCount}
                    onPageChange={handlePageChange}
                    size={isMobile ? PaginationSize.SM : PaginationSize.MD}
                    siblingsCount={isMobile ? 0 : 1}
                />
            )}
        </>
    );
});

const propertyListWrapperStyle = css({
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
    "& > ul": {
        px: 0,
        width: "100%"
    }
});
